// All variables
const mainHEADER = document.querySelector(".WI_header_main");
const MEGAcon = document.querySelector(".WI_headermegaMENU_con");
const MEGAlink = document.querySelectorAll(".MEGA");
const MEGAlogo = document.querySelector(".WI_header_left_img");
const MEGAnav = document.querySelector(".WI_header_left_nav");
const MEGAsearch = document.querySelector(".WI_header_right_search");
const MEGAcart = document.querySelector(".WI_header_right_cart");
const linkLI = document.querySelectorAll(".linkLI");
const linkLI_A = document.querySelectorAll(".linkLI_A");
const mobileMenuBUTTON = document.querySelector(".WI_header_right_menu");
const searchBUTTON = document.querySelector(".WI_header_right_search");
var cartBUTTON = document.querySelector(".WI_header_right_cart");
const searchCLOSE = document.querySelector(".WI_header_right_close");
const searchCON = document.querySelector(".WI_search_con");
const searchINPUT = document.querySelector("#Search");
const searchTRANDING = document.querySelector(".WI_search_tranding");
const cartMAIN = document.querySelector(".WI_cart_main");
const cartDRAWER = document.querySelector(".WI_cart_drawer");
const cartDRAWERCLOSE = document.querySelector(".cart_close");
const moreOPTIONBODY = document.querySelector(".WI_quickOptions_pop_con");
const moreOPTIONPOPUP = document.querySelector(".WI_moreOption_pop_in");
const sortOPTIONS = document.getElementById("sort-by");
const upSellCon = document.querySelector(".WI_cartUPsell");
var multiOptionsloop = true;
const upsellCon = document.querySelector(".WI_cartUpsell_in");
const upsellCon_mobo = document.querySelector(".WI_cartUpsell_in_mobo");
var newsletterButton = document.getElementById("newsletterpop_open");
var newsletterBody = document.querySelector(".WI_newsPopup_main");
var newsletterIn = document.querySelector(".WI_newsPopup_in");
var newsletterClose = document.getElementById("newPop_cls");
const productACTloading = document.querySelector(".WI_product_ATC");
const SearchMain = document.getElementById("WI_search_main");
const emptyCartBtn = document.querySelector(".emptyCartA");
const variantInput = document.querySelectorAll(".popUpVariantInput");
var inventoryMsg = document.getElementsByClassName("inventoryMsg");
import {
	subscribeToCartAjaxRequests,
	configureCart,
	cartRequestAdd,
	getCartState
} from '//www.powerculture.dk/cdn/shop/t/155/assets/liquid-ajax-cart-v1.11.0.js?v=4957411666158762891740197181';
configureCart('updateOnWindowFocus', false);
const cartSTATE = getCartState();
		if (cartSTATE.cart.item_count > 0) {
			document.querySelector(".desktopcartnumber").style.display = "block";
			document.querySelector(".mobilecartnumber").style.display = "block";
			document.querySelector(".WI_cart_freeSgipping").style.display = "flex";
			document.querySelector(".WI_cart_items_con").style.display = "block";
			document.querySelector(".WI_cart_footer").style.display = "flex";
			document.querySelector(".WI_emptyCart_con").style.display = "none";
		}
subscribeToCartAjaxRequests((requestState, subscribeToResult) => {
	
	subscribeToResult(requestState => {
		const aftercartState = getCartState();
		setTimeout(()=>{
		if (aftercartState.cart.item_count > 0) {
			document.querySelector(".desktopcartnumber").style.display = "block";
			document.querySelector(".mobilecartnumber").style.display = "block";
			document.querySelector(".WI_cart_freeSgipping").style.display = "flex";
			document.querySelector(".WI_cart_items_con").style.display = "block";
			document.querySelector(".WI_cart_footer").style.display = "flex";
			document.querySelector(".WI_emptyCart_con").style.display = "none";
		}else{
			document.querySelector(".desktopcartnumber").style.display = "none";
			document.querySelector(".mobilecartnumber").style.display = "none";
			document.querySelector(".WI_cart_freeSgipping").style.display = "none";
			document.querySelector(".WI_cart_items_con").style.display = "none";
			document.querySelector(".WI_cart_footer").style.display = "none";
			document.querySelector(".WI_emptyCart_con").style.display = "flex";
		}
		},100)
		if (productACTloading != null) {
			productACTloading.querySelector(".buttonSPAN").style.display = "block";
			productACTloading.querySelector(".loading_div").style.display = "none";	
		}
		// forRelated();
		var tesst = document.querySelector(".OGcartTotalPrice").innerHTML.split(",00")[0] + " kr";
    	document.querySelector(".cartTotalPrice").innerHTML = tesst;
		document.querySelector(".btncartTotalPrice").innerHTML = tesst + " - ";
		forRelated(upsellCon_mobo,'.prorec_mobo','.WI_cartUpsell_rec_mobo');
		openCART();
		freeShippingBar();
		moreOPTIONSCLS();
	})
})
var tesst = document.querySelector(".OGcartTotalPrice").innerHTML.split(",00")[0] + " kr";
document.querySelector(".cartTotalPrice").innerHTML = tesst;
document.querySelector(".btncartTotalPrice").innerHTML = tesst + " - ";

// Mega menu js
for (let i = 0; i < MEGAlink.length; i++) {
	MEGAlink[i].addEventListener("mouseover", () => {
		mainHEADER.style.height = "500px";
		mainHEADER.style.transition = "0.2s ease-out"
		mainHEADER.classList.add("header_blur_main_js");
		MEGAlogo.classList.remove("header_blur_main_js");
		MEGAnav.classList.remove("header_blur_main_js");
		MEGAsearch.classList.remove("header_blur_main_js");
		MEGAcart.classList.remove("header_blur_main_js");
		document.body.style.overflow = "hidden";
	})
	MEGAlink[i].addEventListener("mouseout", () => {
		mainHEADER.style.height = "auto";
		mainHEADER.classList.remove("header_blur_main_js");
		MEGAlogo.classList.add("header_blur_main_js");
		MEGAnav.classList.add("header_blur_main_js");
		MEGAsearch.classList.add("header_blur_main_js");
		MEGAcart.classList.add("header_blur_main_js");
		searchBUTTON.style.display = "flex";
		cartBUTTON.style.display = "flex";
		document.body.style.overflow = "auto";
	})
}
function handleAnnIntersection(entries, observer) {
	entries.forEach(entry => {
	  if (entry.isIntersecting) {
		document.querySelector('.WI_header_main').style.marginTop = "35px";
	  }else{
		document.querySelector('.WI_header_main').style.marginTop = "0px";
	  }
	});
  }
  var Annoptions = {
	root: null,
	rootMargin: '0px',
	threshold: 0.5,
  };

  var Annobserver = new IntersectionObserver(handleAnnIntersection, Annoptions);
  const AnntargetElement = document.querySelector('.WI_ann_main');
  if (AnntargetElement != null) {
	Annobserver.observe(AnntargetElement);
  };
//Menu Below Line and opacity change
linkLI_A.forEach((item, index) => {
	item.addEventListener('mouseover', () => {
		linkLI_A.forEach((sibling, siblingIndex) => {
			if (siblingIndex !== index) {
				sibling.style.opacity = "0.4";
			  }
			  if (siblingIndex == index) {
				sibling.classList.add('underline');
				if (sibling.nextElementSibling != null) {
					sibling.nextElementSibling.addEventListener("mouseover",()=>{
						sibling.querySelector(".WI_LI_below_line").style.display = "block";
						let fadeLI = sibling.parentElement.parentElement.children;
						for (let i = 0; i < fadeLI.length; i++) {
							let fadeLIS = fadeLI[i].querySelector(".linkLI_A");
							let nofadeLI = sibling;
							if (fadeLIS !== nofadeLI) {
								fadeLIS.style.opacity = "0.4";
							}
							
						}
					})
					sibling.nextElementSibling.addEventListener("mouseout",()=>{
						sibling.querySelector(".WI_LI_below_line").style.display = "none";
						let fadeLI = sibling.parentElement.parentElement.children;
						for (let i = 0; i < fadeLI.length; i++) {
							let fadeLIS = fadeLI[i].querySelector(".linkLI_A");
							fadeLIS.style.opacity = "1";
						}
						sibling.classList.remove('underline');
					})
				}
				
			  }
		})
	})

	item.addEventListener('mouseout', () => {
		linkLI_A.forEach((sibling) => {
			sibling.style.opacity = "1";
			sibling.classList.remove('underline');
		});
	  });
})

// Open search box
searchBUTTON.addEventListener("click", function() {
	SearchMain.style.display = "block";
	setTimeout(()=>{
	SearchMain.classList.add("header_blur_main_js");
	searchCON.style.visibility = "visible";
	searchCON.style.opacity = "1";
	searchCLOSE.style.opacity = "1";
	document.body.style.overflow = "hidden"
	},100);
});

// Close search box
searchCLOSE.addEventListener("click", function() {
	document.body.style.overflow = "auto";
	searchCLOSE.style.opacity = "0";
	searchCON.style.opacity = "0";
	searchCON.style.visibility = "hidden";
	SearchMain.classList.remove("header_blur_main_js");
	setTimeout(()=>{
	SearchMain.style.display = "none";
	},300);

})

// Search input
searchINPUT.addEventListener("keyup", function() {

	if (searchINPUT.value != "") {
		searchTRANDING.style.display = "none";

	} else {
		setTimeout(() => {
			searchTRANDING.style.display = "flex";
			
		}, 1000);
	}

})

// Cart
cartBUTTON.addEventListener("click", function() {
	openCART();
});

// Cart opening function 
function openCART() {
	cartMAIN.style.display = "flex";
	document.body.style.overflow = "hidden";
	setTimeout(() => {
		cartMAIN.style.transition = "0.2s ease-out";
		cartMAIN.classList.add("header_blur_main_js");
		cartDRAWER.style.transform = "translateX(0)";
		forRelated(upsellCon,'.prorec','.WI_cartUpsell_rec');
	}, 10);
	freeShippingBar();
}

// Cart close btn
cartDRAWERCLOSE.addEventListener("click", function() {
	document.body.style.overflow = "auto";
	cartMAIN.classList.remove("header_blur_main_js");
	cartDRAWER.style.transform = "translateX(480px)";
	upSellCon.style.transform = "translateX(-100px)";
	upSellCon.style.opacity = "0";
	upSellCon.style.visibility = "hidden";

	setTimeout(() => {
		cartMAIN.style.display = "none";
	}, 500);
})

// Cart close outside
cartMAIN.addEventListener("click", function(event){
	if (event.target == cartMAIN) {
		document.body.style.overflow = "auto";
	cartMAIN.classList.remove("header_blur_main_js");
	cartDRAWER.style.transform = "translateX(480px)";
	upSellCon.style.transform = "translateX(-100px)";
	upSellCon.style.opacity = "0";
	upSellCon.style.visibility = "hidden";

	setTimeout(() => {
		cartMAIN.style.display = "none";
	}, 500);
	}
})
// empty cart btn
emptyCartBtn.addEventListener("click", function() {
	document.body.style.overflow = "auto";
	cartMAIN.classList.remove("header_blur_main_js");
	cartDRAWER.style.transform = "translateX(480px)";
	upSellCon.style.transform = "translateX(-100px)";
	upSellCon.style.opacity = "0";
	upSellCon.style.visibility = "hidden";

	setTimeout(() => {
		cartMAIN.style.display = "none";
	}, 500);
})

// Cart Shipping calculation
async function freeShippingBar() {
	const freeShippingvalue = document.getElementById("freeShippingPrice").value;
const freeShippingPara = document.getElementById("freeShippingMsg");
let res = await fetch('/cart.js');
let cartData = await res.json();
const cartPrice = Math.round(cartData.total_price/100);
console.log(cartPrice);
const progressBar = document.getElementById("WI_cart_progress");
if (cartPrice < freeShippingvalue) {
	let lessShippingPrice = freeShippingvalue - cartPrice;
	freeShippingPara.innerHTML = "køb for <strong style='color:rgba(0,0,0,1);'>"+lessShippingPrice+" kr.</strong> mere, og få fri fragt"
	let shippingPercent = parseInt(cartPrice/freeShippingvalue*100);
	progressBar.style.width = shippingPercent+"%";
} else if (cartPrice >= freeShippingvalue){
	freeShippingPara.innerHTML = "Tillykke! Du har opnået gratis fragt."
	progressBar.style.width = '100%';
}
}
// lazy loading image
export function imageLAZYLOAD() {
	const lazyImages = document.querySelectorAll('img[data-lazy-src]');

	function lazyIntersection(entries, observer) {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const lazyImage = entry.target;
				const imageUrl = lazyImage.getAttribute('data-lazy-src');
            
                lazyImage.setAttribute('src', imageUrl);
                lazyImage.onload=function() { 	
                lazyImage.style.visibility = "visible";
              lazyImage.style.opacity = "1";
                }
				
				// lazyImage.parentElement.style.height = "auto"
              // lazyImage.style.transition = "0.3s ease-out";
              // lazyImage.style.visibility = "hidden";
              // lazyImage.style.opacity = "0";
				observer.unobserve(lazyImage);
			}
		});
	};
	const options = {
		root: null,
		rootMargin: '0px',
		threshold: 0,
	};
	var observer = new IntersectionObserver(lazyIntersection, options);
	lazyImages.forEach(image => {
		observer.observe(image);
	});
};
imageLAZYLOAD();

// Product card Single options 
function singleProductOptionADD(extCLASS) {
	if(extCLASS == "upsell_product") {
		var productcardVARIANTBTN = document.querySelectorAll(".upsell_product");
	}else if(extCLASS == "relat_product") {
		var productcardVARIANTBTN = document.querySelectorAll(".relat_product");
	}else if( extCLASS == "search_product"){
		var productcardVARIANTBTN = document.querySelectorAll(".search_product");
	}
	else {
		var productcardVARIANTBTN = document.querySelectorAll(".normal_product");
	}
	productcardVARIANTBTN.forEach(function(VariantButton) {
		VariantButton.addEventListener("click", function() {
			let variantID = VariantButton.getAttribute("data-varID");
			let options = {
				newQueue: true
			}
			cartRequestAdd({
				items: [{
					id: variantID,
					quantity: 1
				}]
			}, options)
		})
	});
}
singleProductOptionADD("normal_product");

// More options close 
function moreOPTIONSCLS() {
	moreOPTIONBODY.style.transition = "0.2s ease-out";
	moreOPTIONPOPUP.style.transform = "translateY(100%)";
	moreOPTIONPOPUP.style.opacity = "0";
	moreOPTIONBODY.classList.remove("header_blur_main_js");
	setTimeout(() => {
		moreOPTIONBODY.style.display = "none";
	}, 400)
};
moreOPTIONBODY.addEventListener("click",function(e){
	if (e.target == moreOPTIONBODY) {
		moreOPTIONBODY.style.transition = "0.2s ease-out";
	moreOPTIONPOPUP.style.transform = "translateY(100%)";
	moreOPTIONPOPUP.style.opacity = "0";
	moreOPTIONBODY.classList.remove("header_blur_main_js");
	document.body.style.overflow = "auto";
	setTimeout(() => {
		moreOPTIONBODY.style.display = "none";
	}, 400)
	}
})
// Collection page layout change
const layoutCON = document.querySelectorAll(".collection_layout_shift");
const collectionGRID = document.getElementsByClassName("collection_grid");
layoutCON.forEach(elm => {
	elm.addEventListener("click", () => {
		if (elm.innerHTML == "Four") {
			elm.previousElementSibling.style.textDecoration = "none";
			elm.style.textDecoration = "underline";
			for (let i = 0; i < collectionGRID.length; i++) {

				collectionGRID[i].style.width = "calc(25% - 20px)";
				collectionGRID[i].style.maxWidth = "calc(25% - 20px)";
			}
		} else if (elm.innerHTML == "Two") {
			elm.nextElementSibling.style.textDecoration = "none";
			elm.style.textDecoration = "underline";
			for (let j = 0; j < collectionGRID.length; j++) {

				collectionGRID[j].style.width = "calc(50% - 20px)";
				collectionGRID[j].style.maxWidth = "calc(50% - 20px)";
			}
		}
	})
});

// Collection open filter function
const filterBTN = document.getElementById("filterBTN");
const filterMAIN = document.getElementById("filterMAIN");
const filterCON = document.getElementById("filterCon");
const filterVIEW = document.getElementById("filterviewbtn");
if (filterBTN != null) {
// on scroll down filter hide 
function filterBtnIntersection(entries, observer) {
	entries.forEach((entry) => {
	let filterBtnOuter = document.querySelector(".WI_collectionFilter_btn");
	  if (entry.isIntersecting) {
		
		filterBtnOuter.style.bottom = "-10%";
	  }else{
		filterBtnOuter.style.bottom = "4%";
	  }
	});
  }
  const filterBtnOptions = {
	root: null,
	rootMargin: "0px",
	threshold: 0.2,
  };
  const observedFilterBtn = document.querySelector(".Wi_footer_main");
  const observerFilterBtn = new IntersectionObserver(filterBtnIntersection, filterBtnOptions);
  observerFilterBtn.observe(observedFilterBtn);


	filterBTN.addEventListener("click", function() {
		filterBTN.style.opacity = "0";
		filterMAIN.classList.add("header_blur_main_js");
		filterMAIN.style.pointerEvents = "all";
		filterCON.style.display = "flex";
		document.body.style.overflow = "hidden";
		setTimeout(() => {
			filterCON.style.visibility = "visible";
			filterCON.style.opacity = "1";
			filterCON.style.transform = "translateY(0)"
		}, 300);
	});

	// Collection filtering close function 
	filterVIEW.addEventListener("click", function() {
		collectionFetch();
		filterCON.style.transform = "translateY(100px)";
		filterCON.style.opacity = "0";
		filterCON.style.visibility = "hidden";
		document.body.style.overflow = "auto";
		setTimeout(() => {
			filterMAIN.classList.remove("header_blur_main_js");
			filterMAIN.style.pointerEvents = "none";
			filterBTN.style.opacity = "1";
			filterCON.style.display = "none";
		}, 300)

	});
	document.getElementById("filterCLS").addEventListener("click",()=>{
		filterCON.style.transform = "translateY(100px)";
		filterCON.style.opacity = "0";
		filterCON.style.visibility = "hidden";
		document.body.style.overflow = "auto";
		setTimeout(() => {
			filterMAIN.classList.remove("header_blur_main_js");
			filterMAIN.style.pointerEvents = "none";
			filterBTN.style.opacity = "1";
			filterCON.style.display = "none";
		}, 300)
	})
	filterMAIN.addEventListener("click",function(e){
		if (e.target == filterMAIN) {
			filterCON.style.transform = "translateY(100px)";
		filterCON.style.opacity = "0";
		filterCON.style.visibility = "hidden";
		document.body.style.overflow = "auto";
		setTimeout(() => {
			filterMAIN.classList.remove("header_blur_main_js");
			filterMAIN.style.pointerEvents = "none";
			filterBTN.style.opacity = "1";
			filterCON.style.display = "none";
		}, 300)
		}
	})

	// Collection filter price range slider
	const rangeInput = document.querySelectorAll(".filter_range_con input"),
		priceInput = document.querySelectorAll(".filter_price_input input"),
		inputSPAN = document.querySelectorAll(".filter_price_input p"),
		range = document.querySelector(".filter_slider .filter_progress");
	let priceGap = 50;
	rangeInput.forEach(input => {
		input.addEventListener("input", e => {
			let minRange = parseInt(rangeInput[0].value),
				maxRange = parseInt(rangeInput[1].value);
			if (maxRange - minRange < priceGap) {
				if (e.target.className === "min_range") {
					rangeInput[0].value = maxRange - priceGap;
				} else {
					rangeInput[1].value = minRange + priceGap;
				}
			} else {
				priceInput[0].value = minRange;
				priceInput[1].value = maxRange;
				inputSPAN[0].innerHTML = minRange + " kr";
				inputSPAN[1].innerHTML = maxRange + " kr";
				range.style.left = (minRange / rangeInput[0].max) * 100 + "%";
				range.style.right = 100 - (maxRange / rangeInput[1].max) * 100 + "%";
			}
		})
	});

	// Filter active indicator
	function filterIndicator() {
		const filterActive = document.getElementById("WI_filter_active");
		const filterIndicator = document.getElementById("filterIndicator");
		if (filterActive.innerHTML.trim() === "") {
			filterIndicator.style.display = "none";
		} else {
			filterIndicator.style.display = "block";
		}
	};
	filterIndicator();

	// Collection change url
	var changesortURL = "?sort_by=" + sortOPTIONS.value;
	var changefilterURL = "&filter.v.price.gte=&filter.v.price.lte=";

	function replaceURL() {
		setTimeout(() => {
			history.replaceState(null, null, changesortURL.toString() + changefilterURL.toString());
		}, 100);
	}
	// Collection sort 
	sortOPTIONS.addEventListener("change", () => {
		document.getElementById("WI_loadingScreen").style.display = "block";
		let mainURL = window.location;
		if (mainURL.search == "") {
			var collectionsortURL = "?sort_by=" + sortOPTIONS.value;
		} else {
			let oldURL = new URL(window.location.href);
			let newURL = new URLSearchParams(oldURL.search);
			newURL.delete("sort_by");
			newURL.append("sort_by", sortOPTIONS.value);
			var collectionsortURL = "?" + newURL.toString();
		}
		fetch(window.location.pathname + collectionsortURL)
			.then(res => res.text())
			.then(data => {
				let html_div = document.createElement('div');
				html_div.innerHTML = data;
				let html_dom = html_div.querySelector(".collection").innerHTML;
				document.querySelector(".collection").innerHTML = html_dom;
				changesortURL = "?sort_by=" + sortOPTIONS.value;
				replaceURL();
				imageLAZYLOAD();
				singleProductOptionADD("normal_product");
				// multiOptionsProductADD();
			}).catch(error => console.error(error));
	})
	// Collection filtering fetch function
	function collectionFetch() {
		document.getElementById("WI_loadingScreen").style.display = "block";
		let filterFORM = document.getElementById("filterForm");
		var filterURL = new URLSearchParams(new FormData(filterFORM)).toString();
		fetch(window.location.pathname + "?" + filterURL + "&" + "sort_by=" + sortOPTIONS.value)
			.then(res => res.text())
			.then(data => {
				let html_div = document.createElement('div');
				html_div.innerHTML = data;
				let html_dom = html_div.querySelector(".collection").innerHTML;

				document.querySelector(".collection").innerHTML = html_dom;
				changefilterURL = "&" + filterURL;
				replaceURL();
				imageLAZYLOAD();
				singleProductOptionADD("normal_product");
				filterIndicator();
			}).catch(error => console.error(error));
	};
}

// Product page
function addtoCartProductPage() {
	variantInput.forEach(input => {
		input.addEventListener("click",()=>{
		let variantInputForloop = document.getElementsByClassName("popUpVariantInput");
		var variantInputValue = "";
		for (let i = 0; i < variantInputForloop.length; i++) {
			if (variantInputForloop[i].checked) {
				variantInputValue += variantInputForloop[i].value.toLowerCase().replace(" ", "").toString();
			}
		}
	//^^ Working with product json to get variant id
		let productJSON = JSON.parse(document.querySelector(".WI_optionsCon").querySelector('[type="application/json"]').textContent);
		let productVariantInput = document.getElementById("productAtcvariantinput");
		productJSON.forEach(obj => {
			let JSONtitle = obj.title.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
			if(variantInputValue == JSONtitle){
				productVariantInput.value = obj.id;
	//^^ Product page change url
				var changeProductURL = "?variant=" + obj.id;
					setTimeout(() => {
						history.replaceState(null, null, changeProductURL.toString());
					}, 100);
	//^^ Product inventory message show 
				for (let i = 0; i < inventoryMsg.length; i++) {
					inventoryMsg[i].style.display = "none";
					document.querySelector(".PreinventoryMsg").style.display = "none";
					let inventoryData =  Number(inventoryMsg[i].getAttribute('data-inventory-id'));
					if (inventoryData == obj.id) {
						inventoryMsg[i].style.display = "flex";
					}
				}
			}
		})
		})
	});
}
const producMAIN = document.getElementById("WI_main_product_main");
if (producMAIN != null) {
	// Product Add to cart
	// const productATC = producMAIN.querySelector(".WI_product_ATC");
	// productATC.addEventListener("click", function() {
	// 	addtoCartProductPage(producMAIN, ".WI_variantINPUT")
	// });
	addtoCartProductPage();
	// Size chart
	const sizeChartOpen = document.getElementById("sizeCahrtOpen");
	const sizeChartClose = document.getElementById("productSizeClose");
	const sizeChartMain = document.getElementById("sizeChartMain");
	const sizeChartBody = document.getElementById("WI_productSize_in");
	sizeChartOpen.addEventListener("click", () => {
		sizeChartMain.style.display = "flex";
		document.body.style.overflow = "hidden";
		setTimeout(() => {
			sizeChartMain.classList.add("header_blur_main_js");
			sizeChartBody.style.transform = "translateX(0)";
			sizeChartBody.style.visibility = "visible";
			sizeChartBody.style.opacity = "1";
		});
	});
	sizeChartClose.addEventListener("click", () => {
		sizeChartBody.style.opacity = "0";
		sizeChartBody.style.transform = "translateY(100px)";
		sizeChartBody.style.visibility = "hidden";
		sizeChartMain.classList.remove("header_blur_main_js");
		document.body.style.overflow = "auto";
		setTimeout(() => {
			sizeChartMain.style.display = "none";
		}, 250);
	});

	sizeChartMain.addEventListener("click",function(e){
        if (e.target == sizeChartMain) {
			sizeChartBody.style.opacity = "0";
			sizeChartBody.style.transform = "translateY(100px)";
			sizeChartBody.style.visibility = "hidden";
			document.body.style.overflow = "auto";
			sizeChartMain.classList.remove("header_blur_main_js");
			setTimeout(() => {
				sizeChartMain.style.display = "none";
			}, 250);
        }
    })
} else {

}
// product ATC button loading 
if (productACTloading != null) {
	productACTloading.addEventListener("click", ()=>{
		productACTloading.querySelector(".buttonSPAN").style.display = "none";
		productACTloading.querySelector(".loading_div").style.display = "flex";
	})	
}
// Mobile Nav 
const mobileMenu_open = document.querySelector(".WI_header_right_menu");
const mobileMenu_cls = document.querySelector(".mM_h_close");
const mobileMenu_main = document.querySelector(".mobileMenu_main");
const mobileMenu_in = document.querySelector(".mobileMenu_in");
const mM_LI = document.getElementsByClassName("mobileMenu_LI_JS");
const m_back_con = document.querySelector(".mobileMenu_back_con");
const m_back = document.querySelector(".mobileMenu_back");
const m_back_B = document.querySelector(".mobileMenu_back_B");
// Open mobile nav
mobileMenu_open.addEventListener("click", () => {
	mobileMenu_main.style.display = "flex";
	document.body.style.overflow = "hidden";
	setTimeout(() => {
		mobileMenu_in.classList.add("header_blur_main_js");
		document.querySelector(".mobileMenu_head").style.visibility = "visible";
		document.querySelector(".mobileMenu_head").style.opacity = "1";
		document.querySelector(".mobileMenu_body").style.visibility = "visible";
		document.querySelector(".mobileMenu_body").style.opacity = "1";
	}, 10);
})
// Close mobile nav
mobileMenu_cls.addEventListener("click", () => {

	mobileMenu_in.classList.remove("header_blur_main_js");
	document.querySelector(".mobileMenu_head").style.visibility = "hidden";
	document.querySelector(".mobileMenu_head").style.opacity = "0";
	document.querySelector(".mobileMenu_body").style.visibility = "hidden";
	document.querySelector(".mobileMenu_body").style.opacity = "0";
	document.body.style.overflow = "auto";
	setTimeout(() => {
		mobileMenu_main.style.display = "none";
	}, 250);
})
for (let i = 0; i < mM_LI.length; i++) {
	let linkCount = mM_LI[i].childElementCount;
	if (linkCount > 1) {
	mM_LI[i].addEventListener("click", () => {
			mM_LI[i].parentElement.style.left = "-100%";
			mM_LI[i].lastChild.style.visibility = "visible";
			mM_LI[i].lastChild.style.opacity = "1";
			m_back_con.style.display = "flex";
			m_back.style.display = "flex";	
		
		// Pressing back button
		m_back.addEventListener("click", () => {
			mM_LI[i].parentElement.style.left = "0";
			mM_LI[i].lastChild.style.visibility = "hidden";
			mM_LI[i].lastChild.style.opacity = "0";
			m_back_con.style.display = "none";
			m_back.style.display = "none";
		});
		let secondLI = mM_LI[i].lastChild.childNodes;
		for (let j = 0; j < secondLI.length; j++) {
			let linkChildCount = secondLI[j].childElementCount;
				if (linkChildCount > 1) {
			secondLI[j].addEventListener("click", () => {
				
				secondLI[j].parentElement.style.left = "0";
				secondLI[j].lastChild.style.visibility = "visible";
				secondLI[j].lastChild.style.opacity = "1";
				m_back_B.style.display = "flex";	
				
				// Pressing back button
				m_back_B.addEventListener("click", () => {
					secondLI[j].parentElement.style.left = "100%";
					secondLI[j].lastChild.style.visibility = "hidden";
					secondLI[j].lastChild.style.opacity = "0";
					m_back_B.style.display = "none";
				});
			})
		}
		};
	})
}
}
// Search 
class PredictiveSearch extends HTMLElement {
	constructor() {
		super();

		this.input = this.querySelector('input[type="search"]');
		this.predictiveSearchResults = this.querySelector('#predictive-search');

		this.input.addEventListener('input', this.debounce((event) => {
			this.onChange(event);
		}, 300).bind(this));
	}

	onChange() {
		const searchTerm = this.input.value.trim();

		if (!searchTerm.length) {
			this.close();
			return;
		}

		this.getSearchResults(searchTerm);
	}

	getSearchResults(searchTerm) {
		fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
			.then((response) => {
				if (!response.ok) {
					var error = new Error(response.status);
					this.close();
					throw error;
				}

				return response.text();
			})
			.then((text) => {
				const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
				this.predictiveSearchResults.innerHTML = resultsMarkup;
				imageLAZYLOAD();
				singleProductOptionADD("search_product");
				// multiOptionsProductADD();
				this.open();
			})
			.catch((error) => {
				this.close();
				throw error;
			});
	}

	open() {
		this.predictiveSearchResults.style.display = 'block';
	}

	close() {
		this.predictiveSearchResults.style.display = 'none';
	}

	debounce(fn, wait) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn.apply(this, args), wait);
		};
	}
}

customElements.define('predictive-search', PredictiveSearch);
// Upsell cart
function forRelated(container,fetchCon,relateSwiper) {
	const productRecommendationsSection = container; 	
	var sectionID = document.getElementById("cartsectionid").value;
	let inputproductId = document.getElementsByClassName('cart_product_id');
	for (let i = 0; i < inputproductId.length; i++) {
		var productId = "";
		var productId = parseFloat(inputproductId[0].value);
	}
	if (productId != undefined) {
		fetch(window.Shopify.routes.root + "recommendations/products?product_id=" + productId + "&limit=8&section_id=" + sectionID + "&intent=related")
			.then(response => response.text())
			.then((text) => {
				
				var html = document.createElement('div');
				html.innerHTML = text;
				var fecthCON = html.querySelector(fetchCon);
				const recommendations = fecthCON;
				if (recommendations && recommendations.innerHTML.trim().length) {
					productRecommendationsSection.innerHTML = recommendations.innerHTML;
				}
				imageLAZYLOAD();
				singleProductOptionADD("upsell_product");
				// multiOptionsProductADD();
					var desktopUpsell = new Splide( relateSwiper,{
						drag: true,
            speed: 300,
            easing: "ease-out",
            perPage: 4,
            perMove: 1,
            rewind:false,
            gap: 10,
            pagination: false,
			mediaQuery: 'max',
            breakpoints: {
                1024: {
                    perPage: 2,
					arrows: true,
                },
				1300: {
                    perPage: 2,
                },
                1500: {
                    perPage: 3,
                },
            }
					});
					desktopUpsell.mount();
					upSellCon.style.transform = "translateX(0)";
					upSellCon.style.visibility = "visible";
					upSellCon.style.opacity = "1";
			}).catch(error => console.error(error));


	};
};
forRelated(upsellCon_mobo,'.prorec_mobo','.WI_cartUpsell_rec_mobo');

function handleIntersection(entries, observer) {
	entries.forEach(entry => {
		if (document.querySelector('#WI_floatingAtc_main') != null) {
	  if (entry.isIntersecting) {
		
		document.querySelector('#WI_floatingAtc_main').style.transform = "translateY(80px)";
	  }else{
		document.querySelector('#WI_floatingAtc_main').style.transform = "translateY(0)";
	  }
	}
	});
  }
  var atcoptions = {
	root: null,
	rootMargin: '0px',
	threshold: 0.1,
  };

  var atcobserver = new IntersectionObserver(handleIntersection, atcoptions);
  const targetElement = document.querySelector('.WI_product_ATC');
  var footertargetElement = document.querySelector('.WI_footer_social');
  if (targetElement != null) {
	atcobserver.observe(targetElement);
  };
  if (footertargetElement != null) {
	atcobserver.observe(footertargetElement);
  }

function getNextWorkingDay() {
	const now = new Date();
	const currentHour = now.getHours();
	let targetDate;
	if (currentHour >= 14) {
	  targetDate = new Date(now);
	  targetDate.setDate(now.getDate() + 2);
	} else {
	  targetDate = new Date(now);
	  targetDate.setDate(now.getDate() + 1);
	}
	if (targetDate.getDay() === 6) {
	  targetDate.setDate(targetDate.getDate() + 2);
	} else if (targetDate.getDay() === 0) {
	  targetDate.setDate(targetDate.getDate() + 1);
	}
	const danishDayNames = [
	  "Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag"
	];
	const options = { weekday: "long", day: "numeric" };
	const targetDateString = targetDate.toLocaleDateString("da-DK", options);
	return targetDateString;
  }
  const targetDate = getNextWorkingDay();
  document.querySelector(".carttime").innerText = targetDate;
  if (document.querySelector(".carttimeATC") != null) {
	let cartTimeAtc = document.getElementsByClassName("carttimeATC");
	for (let i = 0; i < cartTimeAtc.length; i++) {
		cartTimeAtc[i].innerText = targetDate;	
	}
  }
  //Newsletter popup
  newsletterButton.addEventListener("click", () => {
	newsletterBody.style.display = "flex";
	document.body.style.overflow = "hidden";
	setTimeout(()=>{
		newsletterBody.classList.add("header_blur_main_js");
		newsletterIn.style.transform = "translateY(0)";
		newsletterIn.style.visibility = "visible";
		newsletterIn.style.opacity = "1";
	},50);
  });
  newsletterClose.addEventListener("click", ()=>{
	sessionStorage.setItem("Subscription_thanks", "Done")
	newsletterIn.style.transform = "translateY(100px)";
	newsletterIn.style.opacity = "0";
	newsletterIn.style.visibility = "visible";
	newsletterBody.classList.remove("header_blur_main_js");
	document.body.style.overflow = "auto";
	setTimeout(()=>{
		newsletterBody.style.display = "none";
	},300)
  });
  newsletterBody.addEventListener("click",function(e){
	if (e.target == newsletterBody) {
		sessionStorage.setItem("Subscription_thanks", "Done")
	newsletterIn.style.transform = "translateY(100px)";
	newsletterIn.style.opacity = "0";
	newsletterIn.style.visibility = "visible";
	newsletterBody.classList.remove("header_blur_main_js");
	document.body.style.overflow = "auto";
	setTimeout(()=>{
		newsletterBody.style.display = "none";
	},300)
	}else{

	}

	});

  if (sessionStorage.getItem("Subscription_thanks") == "Done") {
	if (document.getElementById("newsletter_Success").value == "success" ) {
		document.querySelector(".WI_nP_con").style.display = "none";
		document.querySelector(".WI_nP_thanks").style.display = "flex";
	}
  }else{
	if (document.getElementById("newsletter_Success").value == "success" ) {
		document.querySelector(".WI_nP_con").style.display = "none";
		document.querySelector(".WI_nP_thanks").style.display = "flex";
		newsletterBody.style.display = "flex";
		setTimeout(()=>{
			newsletterBody.classList.add("header_blur_main_js");
			newsletterIn.style.transform = "translateY(0)";
			newsletterIn.style.visibility = "visible";
			newsletterIn.style.opacity = "1";
		},50);
	  }
  }
 
  // collection infinti scroll 
  const collectionUL = document.querySelector(".WI_collectionUL");
  if (collectionUL != null) {
  var collection_next_page_url = collectionUL.getAttribute("data-next-page-url");
  function collectionInfinityScroll () {
	if (collection_next_page_url) {
  fetch(collection_next_page_url, {
    method: 'GET',
    headers: {
        'Accept': 'text/html',
    }
})
.then(response => {
    if (!response.ok) {
        throw new Error('Network response was not ok');
    }
    return response.text(); // This tells Fetch to treat the response as text (HTML)
})
.then(next_page => {
	let html = document.createElement('div');
	html.innerHTML = next_page;
	let new_products = html.querySelector(".WI_collectionUL");
	collectionUL.innerHTML += new_products.innerHTML;
	imageLAZYLOAD();
	var collection_new_page_url = html.querySelector(".WI_collectionUL").getAttribute("data-next-page-url");
	// collection_next_page_url = collection_new_page_url;

	collection_next_page_url = collection_new_page_url;
	document.querySelector(".collection_infinit_scroll_loading").classList.remove("collection_loading");
})
.catch(error => {
    console.error('Fetch error:', error);
});
  }
  }

  document.getElementById("CollectionLoadMore").addEventListener("click", function() {
	document.querySelector(".collection_infinit_scroll_loading").classList.add("collection_loading");
	collectionInfinityScroll();
  });
  function collectionIntersection(entries, observer) {
	entries.forEach((entry) => {
	  if (entry.isIntersecting) {
		const button = document.getElementById("CollectionLoadMore");
		if (collection_next_page_url) {
			button.click();	
		}
	  }
	});
  }
  const collectionLoadOptions = {
	root: null,
	rootMargin: "0px",
	threshold: 0.5,
  };
  const observedCollection = document.querySelector(".WI_collection_loadMore_con");
  const observerCollection = new IntersectionObserver(collectionIntersection, collectionLoadOptions);
  observerCollection.observe(observedCollection);
  }

  var productvariantlable = document.querySelectorAll(".WI_variantBTN");
  productvariantlable.forEach(label => {
   label.addEventListener('click', () => {
	var targetId = label.getAttribute('for');
	
    const targetLabel = document.getElementsByClassName(targetId);
    if (targetLabel) {
    	for (let i = 0; i < targetLabel.length; i++) {
			targetLabel[i].click();
		}
    }
   })
  })

// Footer logo IntersectionObserver
const footerLogoObserver = document.getElementById("WI_footerBigSvg");
const footerBigLogo = document.querySelector(".footerBiglogo");
function footerLogoIntersection(entries, observer) {
	entries.forEach((entry) => {
	  if (entry.isIntersecting) {
		
		footerBigLogo.style.opacity = "1";
		footerBigLogo.style.visibility = "visible";
	  }
	});
  };
  const footerLogoOptions = {
	root: null,
	rootMargin: "0px",
	threshold: 0.5,
  };
  const observerCollection = new IntersectionObserver(footerLogoIntersection, footerLogoOptions);
  observerCollection.observe(footerLogoObserver);

// Related Producted 
const productRecommendationsSection = document.querySelector('.WI_related_con');
if (productRecommendationsSection != null) {
const relatedSectionId = document.getElementById("relatSectionID").value;
const relatedProductId = document.getElementById("relatProductID").value;
fetch(window.Shopify.routes.root + "recommendations/products?product_id=" + relatedProductId + "&limit=8&section_id=" + relatedSectionId + "&intent=related")
.then(res => res.text())
.then((text)=> {
	let html = document.createElement('div');
	html.innerHTML = text;
	let recommendations = html.querySelector('.WI_related');
	if (recommendations && recommendations.innerHTML.trim().length) {
				productRecommendationsSection.innerHTML = recommendations.innerHTML;
			}
	imageLAZYLOAD();
	singleProductOptionADD("relat_product");
	var relatedProduct = new Splide( ".WI_featureCollection_productCon",{
	  drag: true,
		speed: 300,
		easing: "ease-out",
		perPage: 4,
		perMove: 1,
		rewind:false,
		gap: 2,
		pagination: false,
		padding: { left: 60, right: 60 },
		mediaQuery: 'max',
		breakpoints: {
			640: {
				drag: true,
				perPage: 2,
				speed: 300,
				easing: "ease",
			},
			800: {
				padding: { left: 20, right: 30 }
			},
			1024: {
				perPage: 2,
			},
			1300: {
				perPage: 3,
			},
		}
	});
	var bar = relatedProduct.root.querySelector( '.my-slider-progress-bar' );
	relatedProduct.on( 'mounted move', function () {
var end = relatedProduct.Components.Controller.getEnd() + 1;
bar.style.width = String( 100 * ( relatedProduct.index + 1 ) / end ) + '%';
} );
	relatedProduct.mount();
})
};

// Review Pop up

    const reviewOpen = document.getElementById('WI_pD_reviewBtn');
    const reviewClose = document.getElementById('reviewClose');
    const reviewMain = document.getElementById('WI_reviewPop_main');
    const reviewBody = document.getElementById('WI_reviewPop_body');
    const reviewBtn = document.getElementById('WI_reviewSubmit_btn');
    const reviewInputCon = document.getElementsByClassName('reviewInputvali');
    const reviewAlert = document.getElementById('alertReview');
    const reviewThank = document.getElementById('WI_reviewPop_thank');
    const reviewCon = document.getElementById('WI_reviewPop_con');

if (reviewOpen != null) {
// review open
reviewOpen.addEventListener("click",()=>{
    reviewMain.style.display = "flex";
    setTimeout(() => {
        reviewMain.classList.add('header_blur_main_js');
        reviewBody.classList.add('congoingUp');
    },10);
});

// review close
reviewClose.addEventListener("click",()=>{
    reviewMain.classList.remove('header_blur_main_js');
    reviewBody.classList.remove('congoingUp');
    setTimeout(() => {
        reviewMain.style.display = "none";
    },210);
});

// review submit button press
    reviewBtn.addEventListener('click', () => {
    //^^ Getting all the review radio input 
    const rr = Array.from(reviewInputCon).map(container => container.getElementsByTagName('input'));
        let rrLenght = rr.length;
        let dd = [];
    //^^ Going through all the input to see if its checked 
        rr.forEach((inputArray, index) => {
            for (let i = 0; i < inputArray.length; i++) {
                console.log(inputArray[i].checked);
                if (inputArray[i].checked == true) {   
                    dd.push(inputArray[i]);
                }
            }
    //^^ this will happen the button pressed
            setTimeout(() => {
                console.log(rrLenght+dd.length);
                if (rrLenght == dd.length) {
                    reviewAlert.style.display = "none";
                    reviewCon.style.display = "none";
                    reviewThank.style.display = "block";
                }else{
                    reviewAlert.style.display = "block";
                    reviewCon.style.display = "block";
                    reviewThank.style.display = "none";
                }
            }, 10);
        });
});
};
